import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/out/order/abnormalPage', Object.assign({}, options, { params }));
